export default __webpack_public_path__ + "static/media/Icon material-live-help.285ad51b.svg";